module.exports = __webpack_public_path__ + "static/promos-a9bde820511c9b75adc5b71a4a56704f.png";